import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc, where } from "firebase/firestore"

const filterAllMateriais = async (filter) => {
  const materiaisRef = collection(db, "materiais");
  const params = []
  const materiaisList = []

  if(filter && filter.isPago)
    params.push(where("isPago", '==', !filter.isPago))

  if (filter && filter.idObra) {
    params.push(where("obra.id", "==", filter.idObra))
  }

  const q = query(materiaisRef, ...params);

  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    materiaisList.push({
      id: doc.id,
      ...doc.data()
    })
  });
  return materiaisList
}

const getAllMateriais = async ()=>{
  const querySnap = await getDocs(query(collection(db, 'materiais')));
  const materiaisList = []
  querySnap.forEach((doc) => {
    materiaisList.push({ id: doc.id, ...doc.data() })
  })
  return materiaisList;
}

const deleteMaterial = async (payload) => {
  const colRef = await doc(db, 'materiais', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

const saveMaterial = async (payload) => {
  const colRef = collection(db, 'materiais')
  await addDoc(colRef, payload)
}

const updateMaterial = async (payload) => {
  const colRef = await doc(db, 'materiais', payload.id);
  await updateDoc(colRef, payload);
}

export { filterAllMateriais, getAllMateriais, saveMaterial, updateMaterial, deleteMaterial }
